export enum CertEuropeSignActionTypes {
    GET_SIGNING_VIEW = 'GET_SIGNING_VIEW',
    GET_PAGES = 'GET_PAGES',
    SIGN_TAG = 'SIGN_TAG',
    UNSIGN_TAG = 'UNSIGN_TAG',
    SEND_VALIDATION_SMS = 'SEND_VALIDATION_SMS',
    SIGN_DOCUMENT = 'SIGN_DOCUMENT',
    RESEND_VALIDATION_SMS = 'RESEND_VALIDATION_SMS',
    CONFIRM_SIGNATURE = 'CONFIRM_SIGNATURE',
}
